import React from "react";
import Newsletter from "../../components/Newsletter";
import About from "./AboutSection";
import Blog from "./BlogSection";
import Career from "./CareerSection";
import Course from "./CourseSection";
import FunFact from "./FunFactSection";
import HomeBanner from "./HomeBanner";
import Team from "./TeamSection";
import WhyChooseUs from "./WhyChooseUsSection";
import Video from "./VideoSection";
import SapMembership from "./SapMembership";

const HomeMain = ({
  events,
  news,
  leadership,
  ecMembers,
  pastPresidents,
  categories,
}) => {
  const categoryMap = categories.reduce((acc, cat) => {
    acc[cat.value] = cat.label;
    return acc;
  }, {});

  return (
    <main>
      <HomeBanner />
      {/* <Category /> */}
      {/* <About /> */}
      <SapMembership />
      <Course events={events} categoryMap={categoryMap} />
      <Video />
      <WhyChooseUs
        leadership={leadership}
        ecMembers={ecMembers}
        pastPresidents={pastPresidents}
      />
      <FunFact />
      <Blog news={news} />

      {/* Pass all 3 groups separately to Team */}
      {/* <Team
        leadership={leadership}
        ecMembers={ecMembers}
        pastPresidents={pastPresidents}
      /> */}

      <Career />
      <Newsletter />
    </main>
  );
};

export default HomeMain;
